export const SearchIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg width='17' height='18' viewBox='0 0 17 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <ellipse cx='7.49714' cy='7.49695' rx='6.49714' ry='6.49695' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M11.9639 12.3359L16.0246 16.3965' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);
